import createSchemerDecorator from '../decorators/createSchemerDecorator'
import SchemerModel from '../SchemerModel'
import {
  ArrayConfig,
  DEFAULT_TABLE_CONFIG,
  DEFAULT_CELL_HEIGHT
} from '../decorators/constants'
import {
  getFieldConfig
} from '../getters'

export const ARRAY = Symbol("schemer.types.ARRAY")

const defaultArrayOfHeightFn = (v: any[]) => {
  // Array.isArray does not work if this is running mobx@4 (legacy).
  return v && v.length && typeof v !== 'string' ? (v.length * DEFAULT_CELL_HEIGHT) : DEFAULT_CELL_HEIGHT
}

export const arrayOf = createSchemerDecorator(
  (
    target: SchemerModel,
    propertyName: string,
    arrayItemTypeDecorator: any // FIXME
  ) : ArrayConfig => {
    
    // initialize subType decorator
    arrayItemTypeDecorator(target, propertyName)

    const itemTypeConfig = getFieldConfig(target, propertyName)

    if (itemTypeConfig.table === true) {
      itemTypeConfig.table = {}
    }
    
    if (typeof itemTypeConfig.table === 'object') {
      if (!itemTypeConfig.table.height) {
        itemTypeConfig.table.height = defaultArrayOfHeightFn
      }
      itemTypeConfig.table = Object.assign({}, DEFAULT_TABLE_CONFIG, itemTypeConfig.table)
    }

    // Override the field config with a "wrapped" set config
    return {
      ...itemTypeConfig,
      '$type': ARRAY,
      '$arrayOfType': itemTypeConfig['$type'],
      // label: `Array of (${itemTypeConfig.label})`
    }
  }
)